module.exports = __webpack_public_path__ + "img/lotto-list-item-bg-light.17c02c28.png";